import _regeneratorRuntime from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";

function sleep(milliseconds) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, milliseconds);
  });
}

function getAppIndex(_x, _x2, _x3) {
  return _getAppIndex.apply(this, arguments);
}

function _getAppIndex() {
  _getAppIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(txn, net, ref) {
    var data, dataObj, id, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = undefined;
            dataObj = undefined;
            id = undefined;
            url = "";
            _context.next = 6;
            return sleep(15000);

          case 6:
            if (ref.EnableDeveloperAPI) {
              url = ref.indexer;
            } else {
              if (!net) {
                url = "https://algoindexer.testnet.algoexplorerapi.io";
              } else {
                url = "https://algoindexer.algoexplorerapi.io";
              }
            }

            _context.next = 9;
            return fetch(url + '/v2/transactions/' + txn);

          case 9:
            data = _context.sent;
            _context.next = 12;
            return data.json();

          case 12:
            dataObj = _context.sent;
            _context.next = 15;
            return dataObj.transaction["created-application-index"];

          case 15:
            id = _context.sent;
            return _context.abrupt("return", id);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAppIndex.apply(this, arguments);
}

function u8array(text) {
  return Uint8Array.from(Array.from(text).map(function (letter) {
    return letter.charCodeAt(0);
  }));
}

function readGlobalState(_x4, _x5, _x6) {
  return _readGlobalState.apply(this, arguments);
}

function _readGlobalState() {
  _readGlobalState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(net, index, ref) {
    var url, appData, appJSON;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = "";

            if (ref.EnableDeveloperAPI) {
              url = ref.indexer;
            } else {
              if (!net) {
                url = "https://algoindexer.testnet.algoexplorerapi.io";
              } else {
                url = "https://algoindexer.algoexplorerapi.io";
              }
            }

            _context2.next = 4;
            return fetch(url + '/v2/applications/' + index);

          case 4:
            appData = _context2.sent;
            _context2.next = 7;
            return appData.json();

          case 7:
            appJSON = _context2.sent;
            return _context2.abrupt("return", appJSON.application.params["global-state"]);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _readGlobalState.apply(this, arguments);
}

function getAsaIndex(_x7, _x8, _x9) {
  return _getAsaIndex.apply(this, arguments);
}

function _getAsaIndex() {
  _getAsaIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(txn, net, ref) {
    var data, dataObj, id, url;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            data = undefined;
            dataObj = undefined;
            id = undefined;
            url = "";
            _context3.next = 6;
            return sleep(15000);

          case 6:
            if (ref.EnableDeveloperAPI) {
              url = ref.indexer;
            } else {
              if (!net) {
                url = "https://algoindexer.testnet.algoexplorerapi.io";
              } else {
                url = "https://algoindexer.algoexplorerapi.io";
              }
            }

            _context3.next = 9;
            return fetch(url + '/v2/transactions/' + txn);

          case 9:
            data = _context3.sent;
            _context3.next = 12;
            return data.json();

          case 12:
            dataObj = _context3.sent;
            _context3.next = 15;
            return dataObj.transaction["created-asset-index"];

          case 15:
            id = _context3.sent;
            return _context3.abrupt("return", id);

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getAsaIndex.apply(this, arguments);
}

export { getAppIndex, getAsaIndex, u8array, readGlobalState };